// import React, { useState, useRef } from 'react';
// import data from '../../femcare-content.json';

// const { keyServices } = data.sections;
// const DESKTOP_VISIBLE = 5;
// const TABLET_VISIBLE  = 3;

// // ── Reusable arrow button ──────────────────────────────────────────────
// export const ArrowBtn = ({ direction, enabled, onClick, size = 10 }) => (
//   <button
//     onClick={onClick}
//     disabled={!enabled}
//     aria-label={direction === 'prev' ? 'Previous' : 'Next'}
//     className="flex-shrink-0 flex items-center justify-center rounded-full bg-white border transition-all duration-200"
//     style={{
//       width: size, height: size,
//       borderColor: enabled ? 'var(--primary-color)' : 'var(--gray-300)',
//       boxShadow: enabled ? '0 2px 10px rgba(0,36,107,0.15)' : 'none',
//       opacity: enabled ? 1 : 0.35,
//       cursor: enabled ? 'pointer' : 'not-allowed',
//     }}
//   >
//     <svg
//       width={size * 0.4} height={size * 0.4}
//       viewBox="0 0 24 24" fill="none"
//       stroke={enabled ? 'var(--primary-color)' : '#9ca3af'}
//       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
//     >
//       {direction === 'prev'
//         ? <polyline points="15 18 9 12 15 6"/>
//         : <polyline points="9 18 15 12 9 6"/>
//       }
//     </svg>
//   </button>
// );

// // ── Dot indicators ─────────────────────────────────────────────────────
// const Dots = ({ total, current, onClick }) => (
//   <div className="flex justify-center gap-1.5 mt-4">
//     {Array.from({ length: total }).map((_, i) => (
//       <button
//         key={i}
//         onClick={() => onClick(i)}
//         aria-label={`Go to slide ${i + 1}`}
//         className="rounded-full transition-all duration-300"
//         style={{
//           width: i === current ? 20 : 7,
//           height: 7,
//           backgroundColor: i === current ? 'var(--primary-color)' : 'var(--gray-300)',
//         }}
//       />
//     ))}
//   </div>
// );

// // ── Carousel (shared by mobile + tablet) ──────────────────────────────
// export const Carousel = ({ items, visibleCount, arrowSize }) => {
//   const [index, setIndex] = useState(0);
//   const maxIndex  = items.length - visibleCount;
//   const canPrev   = index > 0;
//   const canNext   = index < maxIndex;

//   // touch swipe
//   const touchStartX = useRef(null);
//   const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
//   const handleTouchEnd   = (e) => {
//     if (touchStartX.current === null) return;
//     const diff = touchStartX.current - e.changedTouches[0].clientX;
//     if (Math.abs(diff) > 40) {
//       if (diff > 0 && canNext) setIndex(i => i + 1);
//       if (diff < 0 && canPrev)  setIndex(i => i - 1);
//     }
//     touchStartX.current = null;
//   };

//   // Each card occupies (100 / visibleCount)% of the track width
//   const cardPct = 100 / visibleCount;

//   return (
//     <div>
//       <div className="flex items-center gap-2">
//         <ArrowBtn direction="prev" enabled={canPrev} size={arrowSize}
//           onClick={() => setIndex(i => Math.max(0, i - 1))} />

//         <div
//           className="flex-1 overflow-hidden"
//           onTouchStart={handleTouchStart}
//           onTouchEnd={handleTouchEnd}
//         >
//           <div
//             className="flex transition-transform duration-300 ease-in-out"
//             style={{ transform: `translateX(-${index * cardPct}%)` }}

//           >
//             {items.map((item) => (
//               <div
//                 key={item.id}
//                 style={{ width: `${cardPct}%`, flexShrink: 0,
//                 padding: visibleCount === 1 ? "0px" : "0 8px", }}
//               >
//                 <ServiceCard item={item} isFeatured={false} />
//               </div>
//             ))}
//           </div>
//         </div>

//         <ArrowBtn direction="next" enabled={canNext} size={arrowSize}
//           onClick={() => setIndex(i => Math.min(maxIndex, i + 1))} />
//       </div>

//       <Dots total={maxIndex + 1} current={index} onClick={setIndex} />
//     </div>
//   );
// };

// // ── Main component ─────────────────────────────────────────────────────
// const KeyServices = () => {
//   const { id, heading, backgroundImage, items } = keyServices;

//   // Desktop-only carousel state (5 visible)
//   const maxDesktopStart  = Math.max(0, items.length - DESKTOP_VISIBLE);
//   const [desktopStart, setDesktopStart] = useState(0);
//   const canDesktopPrev   = desktopStart > 0;
//   const canDesktopNext   = desktopStart < maxDesktopStart;
//   const desktopVisible   = items.slice(desktopStart, desktopStart + DESKTOP_VISIBLE);


//   return (
//     <section id={id} className="w-full ava-section-gap" style={{ backgroundColor: 'var(--gray-100)' }}>

//       {/* ── Banner ──────────────────────────────────── */}
//       <div
//         className="relative w-full overflow-hidden"
//         style={{ height: 'clamp(170px, 20vw, 260px)' }}
//       >
//         <img
//           src={backgroundImage}
//           alt="Women's healthcare background"
//           className="absolute inset-0 w-full h-full object-cover object-center"
//           draggable={false}
//         />
//         <div className="absolute inset-0" style={{ backgroundColor: 'var(--secondary-color)'}} />
//         <div className="relative z-10 h-full flex items-center justify-center px-6 text-center">
//           <h2
//             className=" ava-heading-lg ava-black-text "
//             style={{ 
//               // fontSize: 'clamp(0.95rem, 2.4vw, 1.85rem)',
//                maxWidth: '800px' 
//               }}
//           >
//             {heading}
//           </h2>
//         </div>
//       </div>

//       {/* ── Cards container ─────────────────────────── */}
//       {/*
//         KEY FIX: negative marginTop pulls cards over the banner.
//         The value must be smaller than (banner height / 2) so the
//         heading text is never fully covered.
//         We cap it at -70px max so heading remains visible at all sizes.
//       */}
//       <div
//         className="container mx-auto px-4 md:px-8"
//         // pb-10 md:pb-14
//         style={{ marginTop: 'clamp(-70px, -8vw, -50px)' }}
//       >

//         {/* ── MOBILE (<640px) — 1 card at a time ── */}
//         <div className="sm:hidden">
//           <Carousel items={items} visibleCount={1} arrowSize={36} />
//         </div>

//         {/* ── TABLET (640px–1023px) — 3 cards with arrows ── */}
//         <div className="hidden sm:block lg:hidden">
//           <Carousel items={items} visibleCount={TABLET_VISIBLE} arrowSize={40} />
//         </div>

//         {/* ── DESKTOP (1024px+) — 5 cols with prev/next ── */}
//         <div className="hidden lg:block">
//           <div className="relative">
//             {items.length > DESKTOP_VISIBLE && (
//               <button
//                 onClick={() => setDesktopStart(i => Math.max(0, i - 1))}
//                 disabled={!canDesktopPrev}
//                 aria-label="Previous services"
//                 className="absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white border transition-all duration-200"
//                 style={{
//                   borderColor: canDesktopPrev ? 'var(--primary-color)' : 'var(--gray-300)',
//                   boxShadow: canDesktopPrev ? '0 2px 12px rgba(0,36,107,0.15)' : 'none',
//                   opacity: canDesktopPrev ? 1 : 0.4,
//                   cursor: canDesktopPrev ? 'pointer' : 'not-allowed',
//                 }}
//               >
//                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
//                   stroke={canDesktopPrev ? 'var(--primary-color)' : '#9ca3af'}
//                   strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                   <polyline points="15 18 9 12 15 6"/>
//                 </svg>
//               </button>
//             )}

//             <div className="grid grid-cols-5 ava-card-gap">
//               {desktopVisible.map((item, index) => (
//                 <ServiceCard
//                   key={item.id}
//                   item={item}
//                   isFeatured={items.length <= DESKTOP_VISIBLE && index === 2}
//                 />
//               ))}
//             </div>

//             {items.length > DESKTOP_VISIBLE && (
//               <button
//                 onClick={() => setDesktopStart(i => Math.min(maxDesktopStart, i + 1))}
//                 disabled={!canDesktopNext}
//                 aria-label="Next services"
//                 className="absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white border transition-all duration-200"
//                 style={{
//                   borderColor: canDesktopNext ? 'var(--primary-color)' : 'var(--gray-300)',
//                   boxShadow: canDesktopNext ? '0 2px 12px rgba(0,36,107,0.15)' : 'none',
//                   opacity: canDesktopNext ? 1 : 0.4,
//                   cursor: canDesktopNext ? 'pointer' : 'not-allowed',
//                 }}
//               >
//                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
//                   stroke={canDesktopNext ? 'var(--primary-color)' : '#9ca3af'}
//                   strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                   <polyline points="9 18 15 12 9 6"/>
//                 </svg>
//               </button>
//             )}
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// // ── Service Card ───────────────────────────────────────────────────────
// const ServiceCard = ({ item, isFeatured }) => (
//   <div
//     // href={item.href || '#'}
//     aria-label={item.title}
//     className="flex flex-col ava-card-mukta bg-white ava-radius-md overflow-hidden h-full"
//     style={{
//       marginTop: isFeatured ? '-14px' : '0px',
//       // boxShadow: isFeatured
//       //   ? '0 8px 32px rgba(0,36,107,0.20)'
//       //   : '0 2px 14px rgba(0,0,0,0.08)',
//     }}
//   >
//     <img
//       src={item.image}
//       alt={item.title}
//       className="w-full block"
//       style={{ height: 'clamp(120px, 14vw, 180px)', objectFit: 'cover', objectPosition: 'center top' }}
//       draggable={false}
//     />
//     <div className="px-3 pt-3 pb-4 md:px-4 flex flex-col gap-1">
//       <h3
//         className="ava-text-subheading"
//         // style={{ color: 'var(--primary-color)' }}
//       >
//         {item.title}
//       </h3>
//       <p className="ava-text-body  ">
//         {item.description}
//       </p>
//     </div>
//   </div>
// );

// export default KeyServices;
import React, { useEffect, useState } from 'react';
import data from '../../femcare-content.json';
import { useNavigate } from 'react-router-dom';

const { keyServices } = data.sections;
const VISIBLE_COUNT = 4;
export const serviceImages = {
  "Physician Consultation": "/images/physicianConsultation.webp",

  "General Endocrinologist Consultation": "/images/endocronology.webp",
  "General obstetrician Consultation": "/images/obestrics.webp",
  "General Consultation": "/images/generalPhysician.webp",
};
// ── Main component ─────────────────────────────────────────────────────
const KeyServices = () => {
  const { id, heading, backgroundImage, items } = keyServices;
  const [services, setServices] = useState([]);
  const navigate = useNavigate();
  const orgId = `6a352e39ab22c07f82b4261a`
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(
          `https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services`
        );

        if (!res.ok) throw new Error("Failed to fetch services");

        const data = await res.json();
        console.log(data, "this is the data")
        setServices(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchServices();
  }, []);
  // const visibleItems = services.slice(0, VISIBLE_COUNT);
  // const visibleItems = services.slice(0, VISIBLE_COUNT).map((service) => ({
  //   ...service,
  //   image:
  //     serviceImages[service.serviceName] ||
  //     "/images/default.jpg",
  // }));
  const visibleItems=services.filter(s=>s.status!=="INACTIVE").map((service)=>({
    ...service,
    image:service.logoUrl?`https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services/logo?objectKey=${encodeURIComponent(service.logoUrl)}`
       : serviceImages[service.serviceName] || "/images/default.jpg",
  })).slice(0,4)

  return (
    <section id={id} className="w-full" style={{ backgroundColor: 'var(--gray-100)' }}>

      {/* ── Banner ──────────────────────────────────── */}
      <div
        className="relative w-full overflow-hidden"
        style={{ height: 'clamp(170px, 20vw, 260px)' }}
      >
        <img
          src={backgroundImage}
          alt="Women's healthcare background"
          className="absolute inset-0 w-full h-full object-cover object-center"
          draggable={false}
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'var(--primary-color)', opacity: 0.52 }} />
        <div className="relative z-10 h-full flex items-center justify-center px-6 text-center">
          <h2
            className="text-white ava-heading-lg"
            style={{ maxWidth: '800px' }}
          >
            {heading}
          </h2>
        </div>
      </div>

      {/* ── Cards container ─────────────────────────── */}
      {/*
        KEY FIX: negative marginTop pulls cards over the banner.
        The value must be smaller than (banner height / 2) so the
        heading text is never fully covered.
        We cap it at -70px max so heading remains visible at all sizes.
      */}
      <div
        className="container mx-auto px-4 md:px-8 pb-10 md:pb-14"
        style={{ marginTop: 'clamp(-70px, -8vw, -50px)' }}
      >
        {/* Static grid, no carousel — 1 col on mobile, 2 on tablet, 4 on desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 ava-card-gap items-stretch">
          {visibleItems.map((item) => (
            <ServiceCard key={item.id} item={item} enableBookNowButton={true}/>
          ))}
        </div>
        <div className='flex justify-center mt-5'>
          <button className='btn-primary ' onClick={() => navigate('/services')}>View All Services</button>
        </div>

      </div>

      <div>
      </div>
    </section>
  );
};

// ── Service Card ───────────────────────────────────────────────────────
// export const ServiceCard = ({ item }) => (
//   <div
//     aria-label={item.title}
//     className="flex flex-col bg-white ava-radius-md overflow-hidden h-full w-full shadow-md "
//     style={{zIndex:"10",
//       height:"inherit"
//     }}
//   >
//     <img
//       src={item.image}
//       alt={item.title}
//       className="w-full block"
//       style={{ height: 'clamp(90px, 9vw, 120px)', objectFit: 'cover', objectPosition: 'center top' }}
//       draggable={false}
//     />
//     <div className="px-3 pt-3 pb-4 md:px-4 flex flex-col gap-1">
//       <h3 className="ava-text-subheading">
//         {item.serviceName}
//       </h3>
//       <p className="ava-text-body">
//         {item.description}
//       </p>
//             <div className="mt-2 space-y-3 ">
//         <div className="flex items-center text-sm text-gray-600">
//           ⏱<span className="ml-2 ava-text-sm">{item.duration} mins</span>
//         </div>

//         {/* <div className="flex items-start text-sm text-gray-600">
//           📍
//           <span className="ml-2 ava-text-sm line-clamp-1">
//             {item.consultationModes
//               ?.filter((m) => m.name)
//               .map((m) => m.name)
//               .join(" | ")}
//           </span>
//         </div> */}

//         <div className="flex items-center text-sm text-gray-600">
//           🏥<span className="ml-2 ava-text-sm line-clamp-1">{item.serviceType || "Consultation"}</span>
//         </div>
//       </div>

//       {/* Price */}
//       <div className="mt-2 ava-text-subheading">₹{item.price}</div>
//       {/* Buttons pinned to bottom */}
//       <div className="mt-auto pt-6 flex gap-3 flex justify-center">

//         <button className="btn-secondary" >Book Now</button>
//       </div>
//     </div>
//   </div>
// );
export const ServiceCard = ({ item, enableBookNowButton = false, }) => {
  const navigate = useNavigate()

  return (
    <div
      aria-label={item.title}
      className="flex flex-col bg-white ava-radius-md overflow-hidden  ava-card-mukta"
      style={{ zIndex: "10", height: "100%" }}
    >
      <img
        src={item.image}
        alt={item.title}
        className="w-full block"
        style={{ height: 'clamp(190px, 9vw, 120px)', objectFit: 'cover', objectPosition: 'center top' }}
        draggable={false}
      />
      {/* ✅ flex-1 makes this div grow to fill remaining card height */}
      <div className="px-3 pt-3 pb-4 md:px-4 flex flex-col gap-1 flex-1">
        <h3 className="ava-text-subheading">
          {item.serviceName}
        </h3>
        <p className="ava-text-body 
    
      ">
          {/*   line-clamp-2 */}
          {item.description}
        </p>
        <div className="mt-2 space-y-3">
          <div className="flex items-center text-sm text-gray-600">
            ⏱<span className="ml-2 ava-text-sm">{item.duration} mins</span>
          </div>
          <div className="flex items-center text-sm text-gray-600">
            🏥<span className="ml-2 ava-text-sm line-clamp-1">{item.consultationModes ? item.consultationModes.map((mode) => mode.name).join(" | ") : "Consultation"}</span>
          </div>
        </div>

        <div className="mt-2 ava-text-subheading">₹{item.price}</div>

        {/* ✅ mt-auto now works because the parent flex-col has room to push against */}
        {enableBookNowButton && (
          <div className="mt-auto pt-6 flex ">
            <button className="btn-secondary"
              onClick={() => navigate('/book-appointment')}
            >Book Now</button>
          </div>
        )}
      </div>
    </div>
  );
}
export default KeyServices;